// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.list-ios > .item-block:first-child {
  border-top: none !important;
}

.list-ios > .item-block:last-child,
.list-ios > .item-wrapper:last-child .item-block {
  border-bottom: none !important;
}

ion-content {
  position: absolute !important;
  margin-top: 60px !important;
  margin-bottom: 56px;
}

.back-color {
  background: transparent !important;
  padding-left: 16px !important;
}

ion-item {
  --inner-item-end: none !important;
}

.clk-icon ion-icon {
  display: inline-block;
  font-size: 1.8em;
  margin-top: 13px;
  color: #4f5673 !important;
}

textarea.text-input {
  display: block;
  padding-top: 16px;
  --background-color: #f7f7f7 !important;
  padding-left: 10px !important;
}

.text-input {
  margin-top: -2px;
  padding: 0;
  width: calc(100% - 0px - 0px);
  padding-bottom: 11px;
  margin: 0px !important;
}

ion-footer {
  background: #ffffff;
  box-shadow: 0px -1px 0px rgba(221, 217, 217, 0.4);
  position: absolute !important;
  bottom: 0px;
}

ion-content {
  background-size: cover;
  height: 100%;
  overflow: hidden;
}
ion-content .item-md,
ion-content .item-ios {
  background: none;
}

.chat-status {
  min-height: 49px;
}
.chat-status .chat-date {
  display: block;
  font-size: 10px;
  font-style: italic;
  color: #fff;
  text-shadow: 0px -1px 0px #222, 0px 1px 0px #aaa;
  height: 15px;
  left: 10%;
  right: 10%;
}
.chat-status .chat-content-center {
  padding: 5px 10px;
  background-color: #e1e1f7;
  border-radius: 6px;
  font-size: 12px;
  color: #555;
  height: 34px;
  left: 10%;
  right: 10%;
}

.chat-message {
  width: 80%;
  min-height: 40px;
}
.chat-message .right-bubble {
  position: relative;
  background: #dcf8c6;
  border-top-left-radius: 0.4em;
  border-bottom-left-radius: 0.4em;
  border-bottom-right-radius: 0.4em;
  padding: 0px 10px 10px;
  left: 19%;
  margin-top: 10px;
}
.chat-message .right-bubble span.msg-name {
  font-size: 12px;
  font-weight: bold;
  color: green;
}
.chat-message .right-bubble span.msg-date {
  font-size: 10px;
}
.chat-message .right-bubble:after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: 0;
  height: 0;
  border: 21px solid transparent;
  border-left-color: #dcf8c6;
  border-right: 0;
  border-top: 0;
  margin-top: -0.5px;
  margin-right: -12px;
}
.chat-message .left-bubble {
  position: relative;
  background: #eaeaef;
  border-top-right-radius: 0.4em;
  border-bottom-left-radius: 0.4em;
  border-bottom-right-radius: 0.4em;
  padding: 0px 1px 1px;
  left: 7%;
  margin-top: 5px;
  padding-left: 8px;
  padding-bottom: 8px;
}
.chat-message .left-bubble span.msg-name {
  font-size: 12px;
  font-weight: bold;
  color: blue;
}
.chat-message .left-bubble span.msg-date {
  font-size: 10px;
}
.chat-message .left-bubble:after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  border: 12px solid transparent;
  border-right-color: #eaeaef;
  border-left: 0;
  border-top: 0;
  margin-top: -0.5px;
  margin-left: -12px;
}

.button-cancel {
  float: right;
  position: relative;
  margin-top: -54px;
}

.image-none {
  display: none;
}

.image-size {
  margin-top: 5px;
  margin-left: -4px;
  margin-right: 53px;
  width: 45px;
  height: 50px;
}

ion-textarea {
  background-color: #f7f7f7 !important;
}

.img-size {
  object-fit: cover;
  width: 100%;
  height: 150px;
  padding-top: 7px;
}

.download {
  margin-right: -15px !important;
}

[margin-top-0] {
  margin-top: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/app/right-menu/live-chat/live-chat.component.scss"],"names":[],"mappings":"AACA;EACE,2BAAA;AAAF;;AAGA;;EAEE,8BAAA;AAAF;;AAGA;EACE,6BAAA;EACA,2BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kCAAA;EACA,6BAAA;AAAF;;AAGA;EACE,iCAAA;AAAF;;AAIE;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AADJ;;AAKA;EACE,cAAA;EACA,iBAAA;EACA,sCAAA;EACA,6BAAA;AAFF;;AAKA;EACE,gBAAA;EACA,UAAA;EACA,6BAAA;EACA,oBAAA;EACA,sBAAA;AAFF;;AAKA;EACE,mBAAA;EACA,iDAAA;EACA,6BAAA;EACA,WAAA;AAFF;;AAKA;EAEE,sBAAA;EACA,YAAA;EACA,gBAAA;AAHF;AAKE;;EAEE,gBAAA;AAHJ;;AAOA;EACE,gBAAA;AAJF;AAME;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,gDAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAJJ;AAOE;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AALJ;;AASA;EACE,UAAA;EACA,gBAAA;AANF;AAQE;EACE,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;EACA,iCAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AANJ;AAQI;EACE,eAAA;EACA,iBAAA;EACA,YAAA;AANN;AASI;EACE,eAAA;AAPN;AAWE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,0BAAA;EACA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;AATJ;AAYE;EACE,kBAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;EACA,iCAAA;EACA,oBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAVJ;AAYI;EACE,eAAA;EACA,iBAAA;EACA,WAAA;AAVN;AAaI;EACE,eAAA;AAXN;AAeE;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;EACA,2BAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;AAbJ;;AAiBA;EACE,YAAA;EACA,kBAAA;EACA,iBAAA;AAdF;;AAiBA;EACE,aAAA;AAdF;;AAiBA;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAdF;;AAiBA;EAEE,oCAAA;AAfF;;AAkBA;EACE,iBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;AAfF;;AAkBA;EACE,8BAAA;AAfF;;AAkBA;EACE,0BAAA;AAfF","sourcesContent":["// header two line for ios\n.list-ios > .item-block:first-child {\n  border-top: none !important;\n}\n\n.list-ios > .item-block:last-child,\n.list-ios > .item-wrapper:last-child .item-block {\n  border-bottom: none !important;\n}\n\nion-content {\n  position: absolute !important;\n  margin-top: 60px !important;\n  margin-bottom: 56px;\n}\n\n.back-color {\n  background: transparent !important;\n  padding-left: 16px !important;\n}\n\nion-item {\n  --inner-item-end: none !important;\n}\n\n.clk-icon {\n  ion-icon {\n    display: inline-block;\n    font-size: 1.8em;\n    margin-top: 13px;\n    color: #4f5673 !important;\n  }\n}\n\ntextarea.text-input {\n  display: block;\n  padding-top: 16px;\n  --background-color: #f7f7f7 !important;\n  padding-left: 10px !important;\n}\n\n.text-input {\n  margin-top: -2px;\n  padding: 0;\n  width: calc(100% - 0px - 0px);\n  padding-bottom: 11px;\n  margin: 0px !important;\n}\n\nion-footer {\n  background: #ffffff;\n  box-shadow: 0px -1px 0px rgba(221, 217, 217, 0.4);\n  position: absolute !important;\n  bottom: 0px;\n}\n\nion-content {\n  //   background: url(../assets/imgs/chat-back.png) no-repeat center center fixed;\n  background-size: cover;\n  height: 100%;\n  overflow: hidden;\n\n  .item-md,\n  .item-ios {\n    background: none;\n  }\n}\n\n.chat-status {\n  min-height: 49px;\n\n  .chat-date {\n    display: block;\n    font-size: 10px;\n    font-style: italic;\n    color: #fff;\n    text-shadow: 0px -1px 0px #222, 0px 1px 0px #aaa;\n    height: 15px;\n    left: 10%;\n    right: 10%;\n  }\n\n  .chat-content-center {\n    padding: 5px 10px;\n    background-color: #e1e1f7;\n    border-radius: 6px;\n    font-size: 12px;\n    color: #555;\n    height: 34px;\n    left: 10%;\n    right: 10%;\n  }\n}\n\n.chat-message {\n  width: 80%;\n  min-height: 40px;\n\n  .right-bubble {\n    position: relative;\n    background: #dcf8c6;\n    border-top-left-radius: 0.4em;\n    border-bottom-left-radius: 0.4em;\n    border-bottom-right-radius: 0.4em;\n    padding: 0px 10px 10px;\n    left: 19%;\n    margin-top: 10px;\n\n    span.msg-name {\n      font-size: 12px;\n      font-weight: bold;\n      color: green;\n    }\n\n    span.msg-date {\n      font-size: 10px;\n    }\n  }\n\n  .right-bubble:after {\n    content: \"\";\n    position: absolute;\n    right: 0;\n    top: 0;\n    width: 0;\n    height: 0;\n    border: 21px solid transparent;\n    border-left-color: #dcf8c6;\n    border-right: 0;\n    border-top: 0;\n    margin-top: -0.5px;\n    margin-right: -12px;\n  }\n\n  .left-bubble {\n    position: relative;\n    background: #eaeaef;\n    border-top-right-radius: 0.4em;\n    border-bottom-left-radius: 0.4em;\n    border-bottom-right-radius: 0.4em;\n    padding: 0px 1px 1px;\n    left: 7%;\n    margin-top: 5px;\n    padding-left: 8px;\n    padding-bottom: 8px;\n\n    span.msg-name {\n      font-size: 12px;\n      font-weight: bold;\n      color: blue;\n    }\n\n    span.msg-date {\n      font-size: 10px;\n    }\n  }\n\n  .left-bubble:after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 0;\n    height: 0;\n    border: 12px solid transparent;\n    border-right-color: #eaeaef;\n    border-left: 0;\n    border-top: 0;\n    margin-top: -0.5px;\n    margin-left: -12px;\n  }\n}\n\n.button-cancel {\n  float: right;\n  position: relative;\n  margin-top: -54px;\n}\n\n.image-none {\n  display: none;\n}\n\n.image-size {\n  margin-top: 5px;\n  margin-left: -4px;\n  margin-right: 53px;\n  width: 45px;\n  height: 50px;\n}\n\nion-textarea {\n  // background-color: #fff;\n  background-color: #f7f7f7 !important;\n}\n\n.img-size {\n  object-fit: cover;\n  width: 100%;\n  height: 150px;\n  padding-top: 7px;\n}\n\n.download {\n  margin-right: -15px !important;\n}\n\n[margin-top-0] {\n  margin-top: 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
